import React from 'react';

interface ClockIconProps extends React.SVGProps<SVGSVGElement> {
	width?: number;
	height?: number;
	fill?: string;
}

export function ClockIcon({ width = 24, height = 24, fill = 'currentColor', ...props }: Readonly<ClockIconProps>) {
	return (
		<svg {...props} fill="none" width={width} height={height} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
				fill={fill}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.25 5.5H12.75V11.6893L16.5303 15.4697L15.4697 16.5303L11.25 12.3107V5.5Z"
				fill={fill}
			/>
		</svg>
	);
}
